export const ANALYTICS_VIEWER_ROLE = 'analyticsViewer';
export const ANALYTICS_ALGORITHM_EDITOR_ROLE = 'analyticsAlgorithmEditor';
export const ANALYTICS_VIEWER_FALLBACK_ROUTE = '/analytics';

export const isAnalyticsViewerRole = (role: string) =>
  role.toLowerCase() === ANALYTICS_VIEWER_ROLE.toLowerCase();

export const isAnalyticsAlgorithmEditorRole = (role: string) =>
  role.toLowerCase() === ANALYTICS_ALGORITHM_EDITOR_ROLE.toLowerCase();

export const isAnalyticsReaderRole = (role: string) =>
  isAnalyticsViewerRole(role) || isAnalyticsAlgorithmEditorRole(role);

export const ANALYTICS_VIEWER_AGGREGATE_ROUTES = [
  '/analytics',
  '/clips-analytics',
  '/cards-analytics',
  '/ads-analytics',
] as const;

const itemAnalyticsRoute =
  /^\/(stories|clips|cards|collections|interstitialAd)\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/analytics$/i;

const normalizePathname = (pathname: string) => {
  const withoutQueryOrHash = pathname.split(/[?#]/, 1)[0];
  const withoutTrailingSlash = withoutQueryOrHash.replace(/\/+$/, '');
  return withoutTrailingSlash || '/';
};

export const isAnalyticsViewerPathAllowed = (pathname: string) => {
  const normalizedPathname = normalizePathname(pathname);

  return (
    ANALYTICS_VIEWER_AGGREGATE_ROUTES.some(
      route => route.toLowerCase() === normalizedPathname.toLowerCase()
    ) || itemAnalyticsRoute.test(normalizedPathname)
  );
};

export const isAnalyticsAlgorithmEditorPathAllowed = (pathname: string) => {
  const normalizedPathname = normalizePathname(pathname);

  return (
    isAnalyticsViewerPathAllowed(normalizedPathname) ||
    normalizedPathname.toLowerCase() === '/algorithms' ||
    normalizedPathname.toLowerCase().startsWith('/algorithms/')
  );
};
